import { forwardRef } from 'react';
import { ActionList as ActionList$1 } from '@primer/react/deprecated';
import sx from '../../sx.js';
import Box from '../Box.js';
import styled from 'styled-components';
import { jsx } from 'react/jsx-runtime';

const ActionListImpl = /*#__PURE__*/forwardRef(function ActionList(props, ref) {
  return /*#__PURE__*/jsx(Box, {
    as: ActionList$1,
    ref: ref,
    ...props
  });
});
const StyledActionListItem = styled(ActionList$1.Item).withConfig({
  shouldForwardProp: prop => prop !== 'sx'
}).withConfig({
  displayName: "ActionList__StyledActionListItem",
  componentId: "sc-1ugfmds-0"
})(["", ""], sx);
const ActionListItem = /*#__PURE__*/forwardRef(({
  as,
  ...props
}, ref) => /*#__PURE__*/jsx(StyledActionListItem, {
  ...props,
  ...(as ? {
    forwardedAs: as
  } : {}),
  ref: ref
}));
function ActionListGroup(props) {
  return /*#__PURE__*/jsx(Box, {
    as: ActionList$1.Group,
    ...props
  });
}
function ActionListDivider(props) {
  return /*#__PURE__*/jsx(Box, {
    as: ActionList$1.Divider,
    ...props
  });
}
const ActionList = Object.assign(ActionListImpl, {
  Item: ActionListItem,
  Group: ActionListGroup,
  Divider: ActionListDivider
});

export { ActionList };
